import cn from 'classnames'
import { memo, PropsWithChildren } from 'react'

import { ILabelProps } from './models'

import styles from './Label.module.scss'

export const Label = memo<PropsWithChildren<ILabelProps>>(({ children, className, innerRef }) => {
  return (
    <div ref={innerRef} className={cn(styles.item, className)}>
      {children}
    </div>
  )
})
